<template>
    <section class="container-fluid">
        <router-view
          keep-alive
          transition
          transition-mode="out-in"
          style="height: 100%;">
        </router-view>
        <!--接口请求Loading Start-->
        <transition name="fade">
            <section class="loading" v-show="LOADING">
                <van-loading></van-loading>
            </section>
        </transition>
        <!--接口请求Loading End-->
    </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
// 解析地址栏参数方法
const qs = (search) => {
    if (typeof search !== 'string' || !search) return search;
    return search.split('&').reduce((res, cur) => {
        const arr = cur.split('=');
        return Object.assign({[arr[0]]: arr[1]}, res);
    }, {});
};
export default {
    computed: {
        ...mapState([
            'LOADING'
        ])
    },
    watch: {
        '$route' () {
            if (window._czc) {
                const {location: {pathname, hash}} = window;
                let contentUrl = pathname + hash;
                let refererUrl = '/';
                // 浏览监控
                window._czc.push(['_trackPageview', contentUrl, refererUrl]);
                // 事件埋点
                // window._czc.push(['_trackEvent', '']);
            }
        }
    },
    mounted () {
        this.getToken();
        this.setUmeng(); // umeng
        window.iosCallback = this.iosCallback; // 解决IOS调用不到VUE方法，将VUE里的方法继承到全局
    },
    methods: {
        ...mapMutations(['setToken']),
        setUmeng () {
            const script = document.createElement('script');
            script.src = 'https://s4.cnzz.com/z_stat.php?id=1281127747&web_id=1281127747';
            script.language = 'JavaScript';
            document.body.appendChild(script);
        },
        getToken () {
            let u = this.$tools.judgeDevice();
            let params = window.location.href.includes('?') && window.location.href.split('?')[1];
            let token;
            if (u === 'android') {
                try {
                    token = window.android.getToken() || qs(params).token;
                    this.setToken({token: token});
                } catch (e) {
                    console.log(e);
                }
            } else if (u === 'ios') {
                try {
                    window.webkit.messageHandlers.getToken.postMessage('iosCallback');
                } catch (e) {
                    console.log(e);
                }
            }
        },
        iosCallback (res) {
            let params = window.location.href.includes('?') && window.location.href.split('?')[1];
            let token = res || qs(params).token;
            this.setToken({token: token});
        }
    }
};
</script>

<style lang="scss">
    @import './styles/app';
</style>
<style lang="scss" scoped>
    .container-fluid {
      height: 100%;
    }
    .loading{
        background-color: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 60px;
        height: 60px;
        z-index: 99999;
        border-radius: px2rem(5);
        .van-loading{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
        }
        .van-loading__text{
            color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue